// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import VueLodash from "vue-lodash";
import lodash from "lodash";
import VueClipboard from "vue-clipboard2";

import i18n from "./i18n";
import iView from "iview";
import "iview/dist/styles/iview.css";
import locale from "iview/dist/locale/ru-RU";
import "@/assets/global.css";

Vue.use(iView, { locale });

Vue.use(VueClipboard);
Vue.config.devtools = process.env.NODE_ENV === "development";

let shared = {
  data: {}
};

shared.install = function() {
  Object.defineProperty(Vue.prototype, "$user", {
    get() {
      return shared;
    },
    set(data) {
      shared = data;
    }
  });
};
Vue.use(shared);

Vue.use(require("vue-moment"));
Vue.use(VueLodash, { name: "custom", lodash: lodash });

Vue.config.productionTip = false;

const link =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4001"
    : "https://rugby-api.mindscape.xyz";
window.link = link;
const base = axios.create({
  baseURL: link,
  headers: { Authorization: "Bearer " + localStorage.getItem("jwt") }
});
base.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401) {
      for (let key in localStorage) {
        window.localStorage.removeItem(key);
      }
      location.reload();
    }
    return Promise.reject(error);
  }
);

Vue.prototype.env = process.env.NODE_ENV;
Vue.prototype.$http = base;
Vue.prototype.api_domain = link + "/";
Vue.prototype.userInfo = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js